import * as wasm from './emojis_bg.wasm';

const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8Memory0 = new Uint8Array();

function getUint8Memory0() {
    if (cachedUint8Memory0.byteLength === 0) {
        cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

const heap = new Array(32).fill(undefined);

heap.push(undefined, null, true, false);

let heap_next = heap.length;

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function getObject(idx) { return heap[idx]; }

let WASM_VECTOR_LEN = 0;

const lTextEncoder = typeof TextEncoder === 'undefined' ? (0, module.require)('util').TextEncoder : TextEncoder;

let cachedTextEncoder = new lTextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length);
        getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len);

    const mem = getUint8Memory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3);
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedInt32Memory0 = new Int32Array();

function getInt32Memory0() {
    if (cachedInt32Memory0.byteLength === 0) {
        cachedInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32Memory0;
}

function dropObject(idx) {
    if (idx < 36) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
    return instance.ptr;
}
/**
* Turn on debug messages
*/
export function init_debug() {
    wasm.init_debug();
}

function isLikeNone(x) {
    return x === undefined || x === null;
}
/**
* A WASM version of EmojiId, allows one to validate emoji ids. NB: This function tests against the **complete set** of
* emojis.
* @param {string} eid
* @param {number | undefined} max_emoji_id_length
* @returns {boolean}
*/
export function is_valid_emoji_id(eid, max_emoji_id_length) {
    const ptr0 = passStringToWasm0(eid, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.is_valid_emoji_id(ptr0, len0, !isLikeNone(max_emoji_id_length), isLikeNone(max_emoji_id_length) ? 0 : max_emoji_id_length);
    return ret !== 0;
}

/**
* @param {string} emoji
* @param {string} path
* @param {string} ext
* @returns {any}
*/
export function getImageLink(emoji, path, ext) {
    const ptr0 = passStringToWasm0(emoji, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(ext, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.getImageLink(ptr0, len0, ptr1, len1, ptr2, len2);
    return takeObject(ret);
}

/**
* Return the average popularity score for a yat, or -1 if the yat is invalid
* @param {string} eid
* @returns {number}
*/
export function popularity(eid) {
    const ptr0 = passStringToWasm0(eid, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.popularity(ptr0, len0);
    return ret;
}

/**
* A container struct for managing a static set of character sets
*/
export class CharacterSet {

    static __wrap(ptr) {
        const obj = Object.create(CharacterSet.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_characterset_free(ptr);
    }
    /**
    * Create a new Emoji Character set. Only emoji belonging to the specified editions will be returned. If you want
    * to include all emoji in a genus, then set `include_siblings` to true, otherwise only canonical emoji and their
    * variants will be included.
    *
    * The `name` is used to retrieve this set when using the other access functions.
    *
    * The function returns true if is a new set, or false, if an old set has been overridden
    * @param {any} editions
    */
    constructor(editions) {
        const ret = wasm.characterset_new(addHeapObject(editions));
        return CharacterSet.__wrap(ret);
    }
    /**
    * Returns the total size of emojis in this set - excluding variants
    * @returns {number}
    */
    len() {
        const ret = wasm.characterset_len(this.ptr);
        return ret >>> 0;
    }
    /**
    * Returns if the set is empty
    * @returns {boolean}
    */
    is_empty() {
        const ret = wasm.characterset_is_empty(this.ptr);
        return ret !== 0;
    }
    /**
    * Returns a vector of active editions for the character set
    * @returns {any}
    */
    editions() {
        const ret = wasm.characterset_editions(this.ptr);
        return takeObject(ret);
    }
    /**
    * Returns the complete emoji set data. The result is a dict of emoji glyph -> Emoji Record
    * @returns {any}
    */
    emojiSet() {
        const ret = wasm.characterset_emojiSet(this.ptr);
        return takeObject(ret);
    }
    /**
    * Returns an array of all supported emoji characters
    * @returns {any}
    */
    charSet() {
        const ret = wasm.characterset_charSet(this.ptr);
        return takeObject(ret);
    }
    /**
    * Returns true if the character exists in the this character set.
    * @param {string} c
    * @returns {boolean}
    */
    isSupported(c) {
        const ptr0 = passStringToWasm0(c, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.characterset_isSupported(this.ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
    * Returns the Emoji record for the given string, if it exists. `null` is
    * returned if the string does not exist in the emoji set
    * @param {string} c
    * @returns {any}
    */
    get(c) {
        const ptr0 = passStringToWasm0(c, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.characterset_get(this.ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Returns names of all not empty emoji groups
    * @returns {any}
    */
    nonEmptyGroups() {
        const ret = wasm.characterset_nonEmptyGroups(this.ptr);
        return takeObject(ret);
    }
    /**
    * @param {string} filter
    * @param {string} option
    * @returns {any}
    */
    filter(filter, option) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(filter, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(option, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.characterset_filter(retptr, this.ptr, ptr0, len0, ptr1, len1);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return a vector of (vector of) variations for each emoji in the provided yat.
    * @param {EmojiId} yat
    * @param {boolean} only_fully_qualified
    * @returns {any}
    */
    variations(yat, only_fully_qualified) {
        _assertClass(yat, EmojiId);
        const ret = wasm.characterset_variations(this.ptr, yat.ptr, only_fully_qualified);
        return takeObject(ret);
    }
    /**
    * @returns {any}
    */
    static filter_options() {
        const ret = wasm.characterset_filter_options();
        return takeObject(ret);
    }
}
/**
* A WASM filter for EmojiGroups. We have to do this because wasm_bindgen does not support exporting of Vec<T> yet
*/
export class EmojiGroups {

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_emojigroups_free(ptr);
    }
    /**
    * @returns {number}
    */
    static count() {
        const ret = wasm.emojigroups_count();
        return ret >>> 0;
    }
    /**
    * Returns names of all emoji groups
    * @returns {any}
    */
    static list() {
        const ret = wasm.emojigroups_list();
        return takeObject(ret);
    }
}
/**
* A WASM wrapper for EmojiId
*/
export class EmojiId {

    static __wrap(ptr) {
        const obj = Object.create(EmojiId.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_emojiid_free(ptr);
    }
    /**
    * Try to generate a new Emoji id from the given string. In javascript, an invalid string will return `undefined`.
    * @param {string} s
    * @param {number | undefined} max_emoji_id_length
    */
    constructor(s, max_emoji_id_length) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(s, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.emojiid_new(retptr, ptr0, len0, !isLikeNone(max_emoji_id_length), isLikeNone(max_emoji_id_length) ? 0 : max_emoji_id_length);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return EmojiId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the canonical representation of the emoji id. This means that all modifiers have been stripped form
    * the original.
    * @returns {string}
    */
    canonical() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emojiid_canonical(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(r0, r1);
        }
    }
    /**
    * Return the preferred representation of the emoji id using the client's skin tone modifiers and emoji siblings.
    * @returns {string}
    */
    preferred() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emojiid_preferred(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(r0, r1);
        }
    }
    /**
    * Get the canonical length - this is how many emojis are in the EmojiId
    * @returns {number}
    */
    len() {
        const ret = wasm.emojiid_len(this.ptr);
        return ret >>> 0;
    }
    /**
    * Set the preferred representation of the emoji id
    * @param {string} new_value
    */
    setPreferred(new_value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(new_value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.emojiid_setPreferred(retptr, this.ptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Returns the instagram url representation of emoji, e.g. `crab.jumping-jack.rum`
    * @returns {string}
    */
    instagramUrl() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emojiid_instagramUrl(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            var ptr0 = r0;
            var len0 = r1;
            if (r3) {
                ptr0 = 0; len0 = 0;
                throw takeObject(r2);
            }
            return getStringFromWasm0(ptr0, len0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(ptr0, len0);
        }
    }
    /**
    * Returns the twitter url representation of emoji, e.g. ``
    * @returns {string}
    */
    punycodeUrl() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emojiid_punycodeUrl(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            var ptr0 = r0;
            var len0 = r1;
            if (r3) {
                ptr0 = 0; len0 = 0;
                throw takeObject(r2);
            }
            return getStringFromWasm0(ptr0, len0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(ptr0, len0);
        }
    }
    /**
    * Get the modified graphemes in an array
    * @returns {any}
    */
    splitPreferred() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emojiid_splitPreferred(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Get the canonical graphemes in an array
    * @returns {any}
    */
    splitCanonical() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.emojiid_splitCanonical(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
/**
* A WASM filter for EmojiSubGroups. We have to do this because wasm_bindgen does not support exporting of Vec<T> yet
*/
export class EmojiSubGroups {

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_emojisubgroups_free(ptr);
    }
    /**
    * @returns {number}
    */
    static count() {
        const ret = wasm.emojisubgroups_count();
        return ret >>> 0;
    }
    /**
    * @returns {any}
    */
    static list() {
        const ret = wasm.emojisubgroups_list();
        return takeObject(ret);
    }
}

export function __wbindgen_json_parse(arg0, arg1) {
    const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
};

export function __wbindgen_json_serialize(arg0, arg1) {
    const obj = getObject(arg1);
    const ret = JSON.stringify(obj === undefined ? null : obj);
    const ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    getInt32Memory0()[arg0 / 4 + 1] = len0;
    getInt32Memory0()[arg0 / 4 + 0] = ptr0;
};

export function __wbindgen_is_null(arg0) {
    const ret = getObject(arg0) === null;
    return ret;
};

export function __wbindgen_is_undefined(arg0) {
    const ret = getObject(arg0) === undefined;
    return ret;
};

export function __wbindgen_object_drop_ref(arg0) {
    takeObject(arg0);
};

export function __wbindgen_string_new(arg0, arg1) {
    const ret = getStringFromWasm0(arg0, arg1);
    return addHeapObject(ret);
};

export function __wbg_log_6af056b79ee9ad99(arg0, arg1) {
    console.log(getStringFromWasm0(arg0, arg1));
};

export function __wbg_new_693216e109162396() {
    const ret = new Error();
    return addHeapObject(ret);
};

export function __wbg_stack_0ddaca5d1abfb52f(arg0, arg1) {
    const ret = getObject(arg1).stack;
    const ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    getInt32Memory0()[arg0 / 4 + 1] = len0;
    getInt32Memory0()[arg0 / 4 + 0] = ptr0;
};

export function __wbg_error_09919627ac0992f5(arg0, arg1) {
    try {
        console.error(getStringFromWasm0(arg0, arg1));
    } finally {
        wasm.__wbindgen_free(arg0, arg1);
    }
};

export function __wbindgen_debug_string(arg0, arg1) {
    const ret = debugString(getObject(arg1));
    const ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    getInt32Memory0()[arg0 / 4 + 1] = len0;
    getInt32Memory0()[arg0 / 4 + 0] = ptr0;
};

export function __wbindgen_throw(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

